import { render, staticRenderFns } from "./UserBlocks.vue?vue&type=template&id=29388298"
import script from "./UserBlocks.vue?vue&type=script&lang=js"
export * from "./UserBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports